// extracted by mini-css-extract-plugin
export var lg = "_4a-4";
export var md = "_4a-3";
export var sm = "_4a-2";
export var xs = "_4a-1";
export var xxs = "_4a-0";